/* @flow */

export const SERIALIZE_CONTENT: string = 'SERIALIZE_CONTENT';
export const CREATE_CONTENT: string = 'CREATE_CONTENT';
export const CREATE_CONTENT_SUCCESS: string = 'CREATE_CONTENT_SUCCESS';

export const serializeContent = (content: CatalogPageContent) => ({
  type: SERIALIZE_CONTENT,
  content,
});

export const createContent = (
  page: CatalogPage,
  platform: CatalogPlatform
) => ({
  type: CREATE_CONTENT,
  page,
  platform,
});



// WEBPACK FOOTER //
// ./src/modules/catalog/actions/contents.js